define(
  'searchComponentLoader',[
    'loadCss'
  ], (
    loadCss
  ) => {
    'use strict';

    const isTouchScreen = Object.prototype.hasOwnProperty.call(window, 'ontouchstart');
    const eventName = isTouchScreen ? 'touchend' : 'click';
    let componentToInteract;
    let loadSearchComponentFunction;

    /**
     * @private
     * loadSearchComponent: load all the search box component pwa
     *
     */
    function loadSearchComponent(searchConfig) {
      componentToInteract.removeEventListener(eventName, loadSearchComponentFunction);
      const cssBundle = document.querySelector(searchConfig.cssBundle);

      if (cssBundle) {
        loadCss(cssBundle.value);
      }

      require(['SearchFormComponent'], (SearchFormComponent) => {
        // eslint-disable-next-line no-unused-vars
        const search = new SearchFormComponent({
          form: document.querySelector(searchConfig.form),
          shouldAlwaysSubmitForm: searchConfig.shouldAlwaysSubmitForm,
          submitButton: document.querySelector(searchConfig.submitButton),
          useAutocompleteForSubmit: searchConfig.useAutocompleteForSubmit,
          validationError: document.querySelector(searchConfig.validationError),
          searchTextField: document.querySelector(searchConfig.searchTextField),
        });
        componentToInteract.click();
      });
    }

    /**
  * @public
  * init: intitialliaze the loader, it attach the events on the given element.
  */
    function init(searchConfig) {
      if (!searchConfig) {
        return;
      }
      componentToInteract = document.querySelector(searchConfig.componentToInteract);

      loadSearchComponentFunction = loadSearchComponent.bind(null, searchConfig);

      if (componentToInteract) {
        componentToInteract.addEventListener(eventName, loadSearchComponentFunction);
      }
    }

    return {
      init
    };
  }
);

